import {default as init, setDefaultOptions} from "surveylabJsAssets/chart/charts";
import Annotations from "highcharts/modules/annotations";
import * as Highcharts from "highcharts";

// noinspection JSUnusedGlobalSymbols
export default function () {
    setDefaultOptions({
        chart: {
            animation: false,
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            column: {
                maxPointWidth: undefined,
                dataLabels: {
                    style: {
                        textOutline: 'none',
                    },
                },
            },
        },
    });

    $(function () {
        Annotations(Highcharts);
    });

    init();
}